import { Link } from "react-router-dom";
import { Bot, Target, MessageCircle, ArrowUpRight } from "lucide-react";
import { CATEGORIES } from "@/lib/catalog";
import { inr } from "@/lib/api";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { waFor } from "@/components/FloatingWhatsApp";
import { track } from "@/lib/analytics";

const ICONS = { "ag-1": Target, "ag-2": Bot };

export const AgenticAI = ({ onConsult, onPay, paying }) => {
  const cat = CATEGORIES.find((c) => c.key === "agentic");
  const total = cat.items.reduce((a, s) => a + s.price, 0);
  return (
    <section id="agentic-ai" className="relative overflow-hidden border-t border-white/10 py-24 sm:py-32" data-testid="agentic-section">
      <div className="pointer-events-none absolute -left-40 top-20 h-[480px] w-[480px] rounded-full bg-[#00F0FF]/10 blur-[140px]" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
        <Reveal>
          <Eyebrow>New · {cat.name}</Eyebrow>
          <div className="mt-6 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <h2 className="max-w-3xl font-display text-4xl font-bold leading-[1.02] tracking-tight text-white sm:text-6xl" data-testid="agentic-title">
              {cat.name}: <span className="text-outline">{cat.sub}</span>
            </h2>
            <div className="rounded-2xl border border-[#00F0FF]/40 bg-[#00F0FF]/10 px-5 py-3" data-testid="agentic-total">
              <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-300">Total category price</p>
              <p className="font-mono text-2xl font-bold text-white">{inr(total)}</p>
            </div>
          </div>
          <Link to="/services/agentic-ai-solutions" data-testid="agentic-learn-more-link" className="group mt-6 inline-flex items-center gap-1 text-sm font-semibold text-[#00F0FF] hover:underline">
            Learn more about Agentic AI Solutions <ArrowUpRight className="h-4 w-4 transition-transform group-hover:rotate-45" />
          </Link>
        </Reveal>
        <div className="mt-12 grid gap-5 md:grid-cols-2">
          {cat.items.map((s, i) => {
            const Icon = ICONS[s.id];
            return (
              <Reveal key={s.id} delay={i * 0.08}>
                <article className="popular-glow flex h-full flex-col rounded-3xl border border-[#00F0FF]/40 bg-[#0E1526] p-6 sm:p-8" data-testid={`agentic-card-${s.id}`}>
                  <div className="flex items-start justify-between gap-4">
                    <span className="grid h-12 w-12 place-items-center rounded-2xl bg-[#00F0FF] text-[#070B14]"><Icon className="h-6 w-6" /></span>
                    <p className="font-mono text-3xl font-bold text-white" data-testid={`agentic-card-${s.id}-price`}>{inr(s.price)}</p>
                  </div>
                  <h3 className="mt-6 font-display text-2xl font-bold text-white sm:text-3xl">{s.name}</h3>
                  <p className="mt-1 font-mono text-xs uppercase tracking-wider text-[#00F0FF]">{s.note}</p>
                  <p className="mt-4 text-sm leading-relaxed text-slate-300 sm:text-base">{s.desc}</p>
                  <p className="mt-3 text-xs text-amber-200/90">{s.fee}</p>
                  <div className="mt-auto grid gap-3 pt-8 sm:grid-cols-2">
                    <button onClick={() => onConsult(s.name, "agentic_section")} data-testid={`agentic-card-${s.id}-consult-button`}
                      className="group flex items-center justify-center gap-2 rounded-full bg-[#00F0FF] py-3.5 text-sm font-semibold text-[#070B14] transition-transform hover:scale-[1.02]">
                      Book Free Consultation <ArrowUpRight className="h-4 w-4 transition-transform group-hover:rotate-45" />
                    </button>
                    <a href={waFor(`the ${s.name} (${inr(s.price)})`)} target="_blank" rel="noopener noreferrer" onClick={() => track("whatsapp_click", { location: "agentic_section", item: s.name })}
                      data-testid={`agentic-card-${s.id}-whatsapp-button`}
                      className="flex items-center justify-center gap-2 rounded-full border border-white/20 py-3.5 text-sm text-white hover:border-[#25D366]">
                      <MessageCircle className="h-4 w-4" /> Enquire on WhatsApp
                    </a>
                    <button onClick={() => onPay([s.id], s.name)} disabled={paying} data-testid={`agentic-card-${s.id}-pay-button`}
                      className="text-sm text-slate-300 underline-offset-4 hover:text-white hover:underline disabled:opacity-50 sm:col-span-2">
                      Or pay {inr(s.price)} online
                    </button>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
